module.exports = __webpack_public_path__ + "img/FigmaDDSSlicePNGd32d79bef07d06da1fd79365d74432b3.d32d79be.png";